import React  from 'react';
import PropTypes from 'prop-types';
import EnvironmentManager from 'Utils/environmentManager';
import { classnames } from 'Utils/classnames';
import Icon from 'Components/Icon';

const CombinationFailMessage = props => {
  const { data, alignCenter, isListItem } = props;

  const message = EnvironmentManager.getParameter('play_combination_fail_message');

  const wrapperClassName = classnames({
    'sbs-decreased-information': true,
    'sbs-decreased-information--center': alignCenter
  });

  return data?.sbsDecreasedColumn
    ? <div className={ wrapperClassName } >
      { isListItem ? <Icon iconName='svgIconSuccess' /> : null }
      <div>
        <span dangerouslySetInnerHTML={ { __html: message } } />
        <b> { data?.columnCount }</b>
      </div>
    </div>
    : null;
};

CombinationFailMessage.propTypes = {
  data: PropTypes.object,
  alignCenter: PropTypes.bool,
  isListItem: PropTypes.bool
};

export default CombinationFailMessage;